module.exports = __webpack_public_path__ + "static/media/icon-thumbs-up.7c39be07.svg";